const ENV_ENVIRONMENT = "VUE_APP_ENVIRONMENT";
const ENV_BACK_END_URL = "VUE_APP_BACK_END_URL";
const ENV_RECAPTCHA_SITE = "VUE_APP_RECAPTCHA_SITE"; // Add VUE_APP_ prefix


const DEVELOPMENT = "development";
const TOKEN_STORE_KEY = "token";
const BEARER_INVALID = "Bearer invalid";

const USER_NAME = "usuarioNombre";
const USER_LAST_NAME = "usuarioApellido";
const USER_ROLE = "usuarioRol"; // Added missing constant
const PROVINCIA = "provincia"; // Added missing constant
const CANTON = "canton"; // Added missing constant
const DISTRITO = "distrito"; // Added missing constant

export {
  ENV_ENVIRONMENT,
  ENV_BACK_END_URL,
  ENV_RECAPTCHA_SITE,
  DEVELOPMENT,
  BEARER_INVALID,
  TOKEN_STORE_KEY,
  USER_NAME,
  USER_LAST_NAME,
  USER_ROLE, // Exporting the added constant
  PROVINCIA, // Exporting the added constant
  CANTON, // Exporting the added constant
  DISTRITO, // Exporting the added constant
};
